import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import {
  ticketCodeChanged,
  tryAddValidatedTicketToSell
} from '../actions/tickets'
import GlobalLoadingIndicator from '../components/global-loading-indicator'
import TicketResaleVerification from '../components/ticket-sell/ticket-resale-verification'
import { Translate } from 'react-redux-i18n'

class TicketCodeSellInput extends Component {
  needsVerification = () => {
    const { ticketInfo } = this.props
    return (
      ticketInfo.verification &&
      ticketInfo.verification.available &&
      !ticketInfo.verified
    )
  }

  canAddTicket = () => {
    const { valid, isFetching } = this.props
    return valid && !isFetching && !this.needsVerification()
  }
  handleSubmit = e => {
    e.preventDefault()
    this.props.dispatch(tryAddValidatedTicketToSell())
  }

  handleChange = e => {
    const { dispatch } = this.props
    const value = e.target.value

    if (value.length <= 20) {
      // if ticket is valid the check fetch is done in here
      dispatch(ticketCodeChanged(value))
    }
  }

  render() {
    const {
      isFetching,
      validationError,
      validationMessage,
      validationTitle,
      valid,
      text,
      ticketCode
    } = this.props

    return (
      <Fragment>
        <div className="ticket-code-container">
          <input
            type="text"
            value={ticketCode}
            onChange={this.handleChange}
            className="ticket-code-input"
            placeholder={text}
          />
          <button
            className="ticket-add-button"
            disabled={!this.canAddTicket()}
            onClick={this.handleSubmit}
          >
            <div className="ticket-add-button-icon-container">
              {isFetching && <GlobalLoadingIndicator center />}
              {validationError && !isFetching && (
                <i className="fa-solid fa-triangle-exclamation fa-2x" />
              )}
              {!isFetching && !validationError && (
                <i className="fa-solid fa-plus fa-2x" />
              )}
            </div>
          </button>
        </div>
        {valid && this.needsVerification() && (
          <TicketResaleVerification
            dispatch={this.props.dispatch}
            ticketCode={ticketCode}
            ticketInfo={this.props.ticketInfo}
            verification={this.props.ticketInfo.verification}
            resaleVerification={this.props.resaleVerification}
          />
        )}
        <div className="ticket-error-container">
          {validationError && (
            <div className="text-center">
              <div className="ticket-sell-error-title">
                {validationTitle || <Translate value="sell_page.not_valid" />}
              </div>
              <div className="ticket-sell-error-message">
                {validationMessage}
              </div>
            </div>
          )}
        </div>
      </Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    ticketCode: state.tickets.ticketCode,
    valid: state.tickets.valid,
    isFetching: state.tickets.isFetching,
    validationError: state.tickets.validationError,
    validationMessage: state.tickets.validationMessage,
    validationTitle: state.tickets.validationTitle,
    inSell: state.tickets.inSell,
    ticketInfo: state.tickets.ticketInfo,
    eventInfo: state.tickets.eventInfo,
    resaleVerification: state.tickets.resaleVerification
  }
}

export default connect(mapStateToProps)(TicketCodeSellInput)
